import Colors from 'builder/styles/colors'
import { Service } from '../types'

export const THEME = {
  documents: {
    primary: Colors.Blue50,
    base: Colors.Blue40,
    soft: Colors.Blue10,
    muted: Colors.Blue20,
    text: Colors.Blue80,
    badge: Colors.Blue15,
    activeIcon: '#E1F2FF',
  },
  jobs: {
    primary: Colors.Indigo50,
    base: Colors.Indigo40,
    soft: Colors.Indigo10,
    muted: Colors.Indigo20,
    text: Colors.Indigo80,
    badge: Colors.Indigo15,
    activeIcon: '#EDEFFF',
  },
  careers: {
    primary: Colors.Green50,
    base: Colors.Green40,
    soft: Colors.Green10,
    muted: Colors.Green20,
    text: Colors.Green80,
    badge: Colors.Green15,
    activeIcon: '#E3F1E9',
  },
}

export const defaultService: Service = {
  id: 'loading',
  title: 'Loading...',
  progress: 0,
  defaultActive: true,
  icon: 'LoadingIcon',
  component: '_',
  data: {},
  getNextActionUrl: () => '',
  theme: {
    primary: '',
    base: '',
    soft: '',
    muted: '',
    text: '',
    badge: '',
    activeIcon: '',
  },
  calculatedProgress: {
    formattedProgress: '',
    percentageProgress: 0,
  },
}
